import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/auth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Home from './pages/Home'
import Artists from './pages/Artists'
import Artist from './pages/Artist'
import Albums from './pages/Albums'
import Album from './pages/Album'
import Movies from './pages/Movies'
import Movie from './pages/Movie'
import TvShows from './pages/TvShows'
import Series from './pages/Series'
import Libraries from './pages/Libraries'
import LikedSongs from './pages/LikedSongs'
import UnplayedLiked from './pages/UnplayedLiked'
import RecentlyAdded from './pages/RecentlyAdded'
import AllSongs from './pages/AllSongs'
import Playlist from './pages/Playlist'
import FileManager from './pages/FileManager'
import Status from './pages/Status'
import Episode from './pages/Episode'
import Users from './pages/Users'
import SpotifyImporter from './pages/SpotifyImporter'
import SpotifyCallback from './pages/SpotifyCallback'
import Upload from './pages/Upload'
import Discover from './pages/Discover'
import Account from './pages/Account'
import Debug from './pages/Debug'
import LinkDevice from './pages/LinkDevice'
import Downloads from './pages/Downloads'
import SharedTrack from './pages/SharedTrack'
import SharedPlaylist from './pages/SharedPlaylist'
import Search from './pages/Search'
import Youtube from './pages/Youtube'
import YoutubeWatch from './pages/YoutubeWatch'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((state) => state.token)
  return token ? <>{children}</> : <Navigate to="/login" />
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((state) => state.token)
  return token ? <Navigate to="/" /> : <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route
        path="/spotify-callback"
        element={
          <PrivateRoute>
            <SpotifyCallback />
          </PrivateRoute>
        }
      />
      {/* Public share routes - no auth required */}
      <Route path="/share/:token" element={<SharedTrack />} />
      <Route path="/share/playlist/:token" element={<SharedPlaylist />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="discover" element={<Discover />} />
        <Route path="youtube" element={<Youtube />} />
        <Route path="youtube/watch/:id" element={<YoutubeWatch />} />
        <Route path="search" element={<Search />} />
        <Route path="artists" element={<Artists />} />
        <Route path="artists/:id" element={<Artist />} />
        <Route path="albums" element={<Albums />} />
        <Route path="albums/:id" element={<Album />} />
        <Route path="movies" element={<Movies />} />
        <Route path="movies/:id" element={<Movie />} />
        <Route path="tv" element={<TvShows />} />
        <Route path="tv/:id" element={<Series />} />
        <Route path="tv/:seriesId/episode/:episodeId" element={<Episode />} />
        <Route path="songs" element={<AllSongs />} />
        <Route path="liked" element={<LikedSongs />} />
        <Route path="unplayed" element={<UnplayedLiked />} />
        <Route path="recently-added" element={<RecentlyAdded />} />
        <Route path="playlists/:id" element={<Playlist />} />
        <Route path="libraries" element={<Libraries />} />
        <Route path="files" element={<FileManager />} />
        <Route path="status" element={<Status />} />
        <Route path="users" element={<Users />} />
        <Route path="importer" element={<SpotifyImporter />} />
        <Route path="upload" element={<Upload />} />
        <Route path="account" element={<Account />} />
        <Route path="debug" element={<Debug />} />
        <Route path="link" element={<LinkDevice />} />
        <Route path="downloads" element={<Downloads />} />
      </Route>
    </Routes>
  )
}
